<template>
  <!-- MODAL Graph Netvox -->
  <b-modal
    id="modalLog"
    size="lg"
    title="ประวัติการแจ้งเตือน"
    ok-title="ปิด"
    ok-only
  >
    <b-row>
      <b-col cols="12">
        <b-card-code
          style="background-color:rgba(0, 0, 0, 0.6);"
        >
          <b-row>
            <b-col
              md="4"
              class="d-flex align-items-center justify-content-start mb-1"
            >
              <label>ประวัติ</label>
              <b-input-group
                size="sm"
                style="padding-left:14px;"
              >
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="ค้นหาประวัติ"
                  label-cols-sm="12"
                  label-cols-md="2"
                  label-cols-lg="2"
                  style=" background-color:rgba(0,0,0, 0.6);"
                />
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                  >
                    ล้าง
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              md="4"
              offset-md="4"
              class="d-flex align-items-center justify-content-end"
            >
              <b-form-group style="padding-right:14px" />
              <b-form-group />
            </b-col>
            <!-- striped
                  responsive -->
            <b-col
              cols="12"
              sm="12"
            >
              <b-table
                hover
                responsive
                :per-page="perPage"
                :current-page="currentPage"
                :items="item"
                :fields="field"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >

                <template #cell(devstate)="data">
                  ระดับน้ำ {{ data.value }} เซ็นติเมตร
                </template>
              </b-table>
            </b-col>

            <b-col
              cols="12"
            >

              <b-card-body
                class="d-flex justify-content-between flex-wrap pt-1"
              >

                <!-- page length -->
                <b-form-group
                  label="Per Page"
                  label-cols="6"
                  label-align="left"
                  label-size="sm"
                  label-for="sortBySelect"
                  class="text-nowrap mb-md-0 mr-1"
                >
                  <b-form-select
                    id="perPageSelect"
                    v-model="perPage"
                    size="sm"
                    style="background-color:rgba(0,0,0, 0.6);"
                    inline
                    :options="pageOptions"
                  />
                </b-form-group>

                <!-- pagination -->
                <div>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    first-number
                    last-number
                    prev-class="prev-item"
                    next-class="next-item"
                    class="mb-0"
                  >
                    <template #prev-text>
                      <feather-icon
                        icon="ChevronLeftIcon"
                        size="18"
                      />
                    </template>
                    <template #next-text>
                      <feather-icon
                        icon="ChevronRightIcon"
                        size="18"
                      />
                    </template>
                  </b-pagination>
                </div>
              </b-card-body>
            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormGroup, BTable, BPagination, BButton, BCardBody, BInputGroup, BInputGroupAppend, BFormInput,
  BFormSelect,
} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'

export default {
  components: {
    BRow,
    BCol,
    BCardCode,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BFormInput,
    BTable,
    BButton,
    BCardBody,
  },
  data() {
    return {
      field: [
        {
          key: 'tdate', label: 'อัพเดทล่าสุด', class: 'text-center', sortable: true,
        },
        {
          key: 'devdesc', label: 'ชื่อ', sortable: true, class: 'text-center',
        },
        {
          key: 'devstate', label: 'รายงาน', class: 'text-center', sortable: true,
        },
      ],
      item: [],
      perPage: 25,
      pageOptions: [25, 50, 100],
      totalRows: '',
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
    computedFields() {
      // If the user isn't an admin, filter out fields that require auth.
      if (this.userData.role === 'user') return this.fields.filter(field => !field.requiresAdmin)
      // If the user IS an admin, return all fields.
      return this.fields
    },
  },
  mounted() {

  },
  methods: {
    eventFlooding(devid) {
      this.selectedID = devid
      axios.post('/eventFlooding', { devid: this.selectedID }).then(response => {
        this.item = response.data
        this.totalRows = response.data.length
      })
        .catch(error => {
          console.log(error)
        })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss" scoped>
.table-responsive{
    font-size: 14px;
}
.table thead th {
  font-size: 14px;
}
.box {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}
</style>
